import HomeHero from 'app/shared/images/landingPageV2/home-hero.png';
import HomeHero2x from 'app/shared/images/landingPageV2/home-hero@2x.png';
import HomeBlockOne from 'app/shared/images/landingPageV2/home-block-1-ico-1.png';
import HomeBlockOne2x from 'app/shared/images/landingPageV2/home-block-1-ico-1@2x.png';

import HomeBlockTwo from 'app/shared/images/landingPageV2/home-block-1-ico-2.png';
import HomeBlockTwo2x from 'app/shared/images/landingPageV2/home-block-1-ico-2@2x.png';
import HomeBlockThree from 'app/shared/images/landingPageV2/home-block-1-ico-3.png';
import HomeBlockThree2x from 'app/shared/images/landingPageV2/home-block-1-ico-3@2x.png';

import HomeBlockThreeImage from 'app/shared/images/landingPageV2/home-block-3-image.jpg';
import HomeBlockThreeImage2x from 'app/shared/images/landingPageV2/home-block-3-image@2x.jpg';
import HomeBlockThreeWide from 'app/shared/images/landingPageV2/home-block-3-overlay-wide.png';
import HomeBlockThreeWide2x from 'app/shared/images/landingPageV2/home-block-3-overlay-wide@2x.png';
import HomeBlockThreeOverlay from 'app/shared/images/landingPageV2/home-block-3-overlay.png';
import HomeBlockThreeOverlay2x from 'app/shared/images/landingPageV2/home-block-3-overlay@2x.png';

import HomeBlockFourImage from 'app/shared/images/landingPageV2/home-block-4-image.jpg';
import HomeBlockFourImage2x from 'app/shared/images/landingPageV2/home-block-4-image@2x.jpg';
import HomeBlockFourWide from 'app/shared/images/landingPageV2/home-block-4-overlay-wide.png';
import HomeBlockFourWide2x from 'app/shared/images/landingPageV2/home-block-4-overlay-wide@2x.png';
import HomeBlockFourOverlay from 'app/shared/images/landingPageV2/home-block-4-overlay.png';
import HomeBlockFourOverlay2x from 'app/shared/images/landingPageV2/home-block-4-overlay@2x.png';

import HomeBlockFiveImage from 'app/shared/images/landingPageV2/home-block-5-image.jpg';
import HomeBlockFiveImage2x from 'app/shared/images/landingPageV2/home-block-5-image@2x.jpg';
import HomeBlockFiveWide from 'app/shared/images/landingPageV2/home-block-5-overlay-wide.png';
import HomeBlockFiveWide2x from 'app/shared/images/landingPageV2/home-block-5-overlay-wide@2x.png';
import HomeBlockFiveOverlay from 'app/shared/images/landingPageV2/home-block-5-overlay.png';
import HomeBlockFiveOverlay2x from 'app/shared/images/landingPageV2/home-block-5-overlay@2x.png';

import HomeBlockSixImage from 'app/shared/images/landingPageV2/home-block-6-image.jpg';
import HomeBlockSixImage2x from 'app/shared/images/landingPageV2/home-block-6-image@2x.jpg';
import HomeBlockSixWide from 'app/shared/images/landingPageV2/home-block-6-overlay-wide.png';
import HomeBlockSixWide2x from 'app/shared/images/landingPageV2/home-block-6-overlay-wide@2x.png';
import HomeBlockSixOverlay from 'app/shared/images/landingPageV2/home-block-6-overlay.png';
import HomeBlockSixOverlay2x from 'app/shared/images/landingPageV2/home-block-6-overlay@2x.png';

import HomeBlockSevenImage from 'app/shared/images/landingPageV2/home-block-7-image.jpg';
import HomeBlockSevenImage2x from 'app/shared/images/landingPageV2/home-block-7-image@2x.jpg';

import CtaBackground from 'app/shared/images/listingLandingPageV2/post-listing-cta-background.jpg';
import CtaBackground2x from 'app/shared/images/listingLandingPageV2/post-listing-cta-background@2x.jpg';

export default {
    HomeHero,
    HomeHero2x,
    HomeBlockOne,
    HomeBlockOne2x,
    HomeBlockTwo,
    HomeBlockTwo2x,
    HomeBlockThree,
    HomeBlockThree2x,

    HomeBlockThreeImage,
    HomeBlockThreeImage2x,
    HomeBlockThreeWide,
    HomeBlockThreeWide2x,
    HomeBlockThreeOverlay,
    HomeBlockThreeOverlay2x,

    HomeBlockFourImage,
    HomeBlockFourImage2x,
    HomeBlockFourWide,
    HomeBlockFourWide2x,
    HomeBlockFourOverlay,
    HomeBlockFourOverlay2x,

    HomeBlockFiveImage,
    HomeBlockFiveImage2x,
    HomeBlockFiveWide,
    HomeBlockFiveWide2x,
    HomeBlockFiveOverlay,
    HomeBlockFiveOverlay2x,

    HomeBlockSixImage,
    HomeBlockSixImage2x,
    HomeBlockSixWide,
    HomeBlockSixWide2x,
    HomeBlockSixOverlay,
    HomeBlockSixOverlay2x,

    HomeBlockSevenImage,
    HomeBlockSevenImage2x,

    CtaBackground,
    CtaBackground2x,
};
